'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIDialogFooter;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _UIButtonWrapper = require('../layout/UIButtonWrapper');

var _UIButtonWrapper2 = _interopRequireDefault(_UIButtonWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ALIGNMENT_OPTIONS = {
  between: 'between',
  left: 'start',
  center: 'center',
  right: 'end'
};

function UIDialogFooter(_ref) {
  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['align', 'children', 'className']);

  return _react2.default.createElement(
    'footer',
    _extends({}, rest, {
      className: (0, _classnames2.default)('private-modal__footer', 'uiDialogFooter', className)
    }),
    _react2.default.createElement(
      _UIButtonWrapper2.default,
      { justify: ALIGNMENT_OPTIONS[align] },
      children
    )
  );
}

UIDialogFooter.propTypes = {
  align: _propTypes2.default.oneOf(['left', 'center', 'right', 'between']).isRequired,
  children: _propTypes2.default.node
};

UIDialogFooter.defaultProps = {
  align: 'left'
};

UIDialogFooter.displayName = 'UIDialogFooter';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/UIDialogFooter.js
// module id = 555
// module chunks = 177